// extracted by mini-css-extract-plugin
export default {"cardListContainer":"ArquivosCardList_cardListContainer__Tqvai"};